import React from "react";
import s from "./style.module.css";
import cn from "classnames";

const Box = ({ title, children, flush, extra, isLoading }) => {
  return (
    <div className={cn(s.wrap, { [s.flush]: flush, [s.isLoading]: isLoading })}>
      <div className={s.title}>
        <div className={s.grid}>
          <span className={s.gi}>
            <h2>{title}</h2>
          </span>
          {extra && <span className={s.gi}>{extra}</span>}
        </div>
      </div>
      <div className={s.children}>
        <div className={s.loader}>
          <svg
            className={s.icon}
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width="32"
            height="32"
            data-icon="loop-circular"
            data-container-transform="translate(0 3)"
            viewBox="0 0 32 32"
          >
            <path
              d="M16 0c-.483-.002-.955.01-1.438.063-1.286.139-2.564.466-3.781 1-4.694 2.061-7.781 6.811-7.781 11.938h-3l4.5 6 4.5-6h-3c0-3.913 2.416-7.614 6-9.188 3.713-1.63 8.196-.772 11.063 2.094l2.125-2.125c-2.466-2.465-5.808-3.77-9.188-3.781zm11.5 7l-4.5 6h3c0 3.913-2.416 7.583-6 9.156-3.713 1.63-8.196.772-11.063-2.094l-2.125 2.125c3.757 3.756 9.536 4.857 14.406 2.719 4.694-2.061 7.781-6.779 7.781-11.906h3l-4.5-6z"
              transform="translate(0 3)"
            />
          </svg>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Box;
